/* ======================================================================== */
/* 11. PJAX Update Admin Bar */
/* ======================================================================== */
function PJAXUpdateAdminBar(data) {
	return new Promise(function (resolve, reject) {
		const
			$elementorAdminBarConfigScript = $('#elementor-admin-bar-js-before'),
			$currentBar = $('#wpadminbar');

		if (!$currentBar.length) {
			resolve(true);
			return;
		}

		const
			rawHTML = $.parseHTML(data.next.html),
			$newBar = $(rawHTML).filter('#wpadminbar');

		$newBar.find('.hide-if-no-customize').removeClass('hide-if-no-customize');
		$currentBar.replaceWith($newBar);

		// re-init Elementor admin bar buttons
		if (document.body.classList.contains('elementor-page') && $elementorAdminBarConfigScript.length) {
			try {
				const nextElementorAdminBarConfigScript = data.next.html.match(/(?:'|")elementor-admin-bar-js-before(?:'|")>([\s\S.]*?)(?:<\/script>)/i)[1];

				// update the script contents
				$elementorAdminBarConfigScript.html(nextElementorAdminBarConfigScript);

				// eval new script params
				window.eval($elementorAdminBarConfigScript.text());

			} catch (err) {
				console.warn(err);
			}
		}

		resolve(true);
	});
}
